import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { ReactComponent as SearchIconT1 } from "Icons/searchIconT1.svg";
const InputT1 = (props) => {
  const { ...rest } = props;

  return (
    <Fragment>
      <InputT1Wrapper>
        <StyledSearchIconT1 />
        <Input   {...rest} />
      </InputT1Wrapper>
    </Fragment>
  );
};

export default InputT1;

const InputT1Wrapper = styled.div`
  position: relative;
`;

const StyledSearchIconT1 = styled(SearchIconT1)`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 52%;
  left: 8px;
  transform: translateY(-50%);
`;

const Input = styled.input`
  min-height: 38px;
  padding-left: 35px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(82, 138, 234, 0.45);
`;
